import _ from 'lodash';
import React from 'react';
import GeometryMixin from '../../../../mixins/geometry-mixin';

export default class extends React.Component {
  static displayName = 'Points';

  static defaultProps = {
    value: [],
    colour: 'black',
    strokeColour: 'black',
    strokeWidth: 1,
    skipZeroDots: true,
    scale: { x: 0, y: 0 },
    radius: 5
  };

  toX = (x, scale) => {
    return `${x * (scale || this.props.scale).x}%`;
  };

  toY = (y, scale) => {
    return `${100 - y * (scale || this.props.scale).y}%`;
  };

  render() {
    let values = this.props.value;
    if (this.props.skipZeroDots) {
      values = this.props.value.filter((v) => v.y !== 0);
    }
    const { scale } = this.props;
    const points = values.map((v, i) => {
      const height = `${v.y * scale.y}%`;
      return (
        <rect
          key={i}
          x={this.toX(v.x)}
          y={this.toY(v.y)}
          height={height}
          width={scale.x + '%'}
          fill={this.props.colour}
          stroke={this.props.strokeColour}
          strokeWidth={this.props.strokeWidth}
        />
      );
    });

    return <g>{points}</g>;
  }
}
